(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Lightswitch-Grid-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lightswitch-grid')) {
    customElements.define(
      'lightswitch-grid',
      class LightswitchGrid extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('[data-lightswitch-toggle]');
          if (!this.toggle) return;
          this.onToggle = this.onToggle.bind(this);
          this.toggle.addEventListener('click', this.onToggle);
        }

        disconnectedCallback() {
          if (this.toggle) this.toggle.removeEventListener('click', this.onToggle);
        }

        onToggle() {
          const on = this.toggle.getAttribute('aria-checked') !== 'true';
          this.toggle.setAttribute('aria-checked', String(on));
          this.classList.toggle('is-lit', on);
          this.dispatchEvent(
            new CustomEvent('lightswitch:change', { bubbles: true, detail: { on } })
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalog-flipbook"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flip-shelf')) {
    const PDFJS_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
    const PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
    let pdfjsPromise = null;

    function loadPdfJs() {
      if (window.pdfjsLib) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
        return Promise.resolve(window.pdfjsLib);
      }
      if (pdfjsPromise) return pdfjsPromise;
      pdfjsPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = PDFJS_SRC;
        script.onload = () => {
          if (!window.pdfjsLib) return reject(new Error('pdf.js nicht verfügbar'));
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
          resolve(window.pdfjsLib);
        };
        script.onerror = () => reject(new Error('pdf.js konnte nicht geladen werden'));
        document.head.appendChild(script);
      });
      return pdfjsPromise;
    }

    class FlipShelf extends HTMLElement {
      connectedCallback() {
        this.viewer = this.querySelector('[data-viewer]');
        this.stage = this.querySelector('[data-stage]');
        this.book = this.querySelector('[data-book]');
        this.leaf = this.querySelector('[data-leaf]');
        this.canvasLeft = this.querySelector('[data-left]');
        this.canvasRight = this.querySelector('[data-right]');
        this.leafFront = this.querySelector('[data-leaf-front]');
        this.leafBack = this.querySelector('[data-leaf-back]');
        this.spinner = this.querySelector('[data-spinner]');
        this.errorBox = this.querySelector('[data-error]');
        this.countEl = this.querySelector('[data-count]');
        this.titleEl = this.querySelector('[data-viewer-title]');
        this.downloadEl = this.querySelector('[data-download]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');

        this.flipMs = Math.max(200, parseInt(this.dataset.flip, 10) || 700);
        this.viewer.style.setProperty('--fbs-flip', this.flipMs + 'ms');

        this.doc = null;
        this.pages = 0;
        this.view = 0;
        this.zoom = 1;
        this.single = false;
        this.ratio = 0.707;
        this.busy = false;
        this.cache = new Map();
        this.opener = null;

        this.onKey = this.onKey.bind(this);

        this.querySelectorAll('[data-open]').forEach((btn) => {
          btn.addEventListener('click', () => this.open(btn));
        });

        this.querySelector('[data-close]').addEventListener('click', () => this.close());
        this.prevBtn.addEventListener('click', () => this.flip(-1));
        this.nextBtn.addEventListener('click', () => this.flip(1));
        this.querySelector('[data-zoom-in]').addEventListener('click', () => this.setZoom(this.zoom + 0.25));
        this.querySelector('[data-zoom-out]').addEventListener('click', () => this.setZoom(this.zoom - 0.25));
        this.querySelector('[data-full]').addEventListener('click', () => this.toggleFullscreen());

        this.viewer.addEventListener('click', (event) => {
          if (event.target === this.stage) this.close();
        });

        // Wischgesten
        let startX = 0;
        let startY = 0;
        this.stage.addEventListener(
          'touchstart',
          (event) => {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );
        this.stage.addEventListener(
          'touchend',
          (event) => {
            const dx = event.changedTouches[0].clientX - startX;
            const dy = event.changedTouches[0].clientY - startY;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.flip(dx < 0 ? 1 : -1);
          },
          { passive: true }
        );

        this.onResize = () => {
          if (this.viewer.hidden) return;
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.fit(true), 150);
        };
        window.addEventListener('resize', this.onResize);

        this.renderCovers();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('keydown', this.onKey);
      }

      // Cover aus der ersten PDF-Seite, wenn kein Bild hinterlegt ist
      renderCovers() {
        const pending = Array.from(this.querySelectorAll('[data-cover-canvas]'));
        if (!pending.length) return;

        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            const canvas = entry.target;
            const btn = canvas.closest('[data-open]');
            const url = btn && btn.dataset.pdf;
            if (!url) return;
            loadPdfJs()
              .then((lib) => lib.getDocument(url).promise)
              .then((doc) => doc.getPage(1))
              .then((page) => {
                const base = page.getViewport({ scale: 1 });
                const width = canvas.clientWidth * (window.devicePixelRatio || 1);
                const viewport = page.getViewport({ scale: Math.max(0.3, width / base.width) });
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                return page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
              })
              .catch(() => {});
          });
        });

        pending.forEach((canvas) => io.observe(canvas));
      }

      async open(btn) {
        const url = btn.dataset.pdf;
        if (!url) return;

        this.opener = btn;
        this.titleEl.textContent = btn.dataset.title || '';
        if (btn.dataset.download === '1') {
          this.downloadEl.href = url;
          this.downloadEl.hidden = false;
        } else {
          this.downloadEl.hidden = true;
        }

        this.viewer.hidden = false;
        requestAnimationFrame(() => this.viewer.classList.add('is-open'));
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', this.onKey);
        this.querySelector('[data-close]').focus();

        this.errorBox.hidden = true;
        this.spinner.hidden = false;
        this.cache.clear();
        this.view = 0;
        this.zoom = 1;

        try {
          const lib = await loadPdfJs();
          this.doc = await lib.getDocument(url).promise;
          this.pages = this.doc.numPages;
          const first = await this.doc.getPage(1);
          const vp = first.getViewport({ scale: 1 });
          this.ratio = vp.width / vp.height;
          this.spinner.hidden = true;
          await this.fit(true);
        } catch (error) {
          this.spinner.hidden = true;
          this.errorBox.hidden = false;
          this.errorBox.textContent =
            'Das PDF konnte nicht geladen werden. Bitte den Link prüfen – er muss direkt auf eine PDF-Datei zeigen.';
        }
      }

      close() {
        this.viewer.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKey);
        document.body.style.overflow = '';
        setTimeout(() => {
          this.viewer.hidden = true;
          if (this.doc) this.doc.destroy();
          this.doc = null;
          this.cache.clear();
          if (this.opener) this.opener.focus();
        }, 250);
      }

      onKey(event) {
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowRight') this.flip(1);
        if (event.key === 'ArrowLeft') this.flip(-1);
      }

      toggleFullscreen() {
        if (document.fullscreenElement) {
          document.exitFullscreen();
        } else if (this.viewer.requestFullscreen) {
          this.viewer.requestFullscreen().catch(() => {});
        }
      }

      setZoom(value) {
        const next = Math.min(3, Math.max(1, Math.round(value * 100) / 100));
        if (next === this.zoom) return;
        this.zoom = next;
        this.cache.clear();
        this.fit(true);
      }

      // Seitengröße an Bühne, Seitenverhältnis und Zoom anpassen
      async fit(rerender) {
        this.single = window.innerWidth < 900;
        this.book.classList.toggle('is-single', this.single);

        const maxW = this.stage.clientWidth - 24;
        const maxH = this.stage.clientHeight - 24;
        const perRow = this.single ? 1 : 2;
        let pw = Math.min(maxW / perRow, maxH * this.ratio);
        pw = Math.max(80, pw * this.zoom);
        const ph = pw / this.ratio;

        this.viewer.style.setProperty('--fbs-pw', pw.toFixed(1) + 'px');
        this.viewer.style.setProperty('--fbs-ph', ph.toFixed(1) + 'px');
        this.pageW = pw;

        if (rerender) await this.update();
      }

      pageNumbers(view) {
        if (this.single) return { left: null, right: Math.min(this.pages, Math.max(1, view + 1)) };
        if (view === 0) return { left: null, right: 1 };
        const left = view * 2;
        const right = left + 1;
        return { left: left <= this.pages ? left : null, right: right <= this.pages ? right : null };
      }

      maxView() {
        if (this.single) return Math.max(0, this.pages - 1);
        return Math.floor(this.pages / 2);
      }

      async update() {
        if (!this.doc) return;
        const { left, right } = this.pageNumbers(this.view);
        await Promise.all([this.draw(left, this.canvasLeft), this.draw(right, this.canvasRight)]);

        const human = this.single
          ? this.view + 1 + ' / ' + this.pages
          : [left, right].filter(Boolean).join('–') + ' / ' + this.pages;
        this.countEl.textContent = human;

        this.prevBtn.disabled = this.view <= 0;
        this.nextBtn.disabled = this.view >= this.maxView();
      }

      async getPageCanvas(num) {
        const key = num + '@' + Math.round(this.pageW);
        if (this.cache.has(key)) return this.cache.get(key);

        const page = await this.doc.getPage(num);
        const base = page.getViewport({ scale: 1 });
        const dpr = Math.min(2, window.devicePixelRatio || 1);
        const viewport = page.getViewport({ scale: (this.pageW * dpr) / base.width });
        const canvas = document.createElement('canvas');
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;

        if (this.cache.size > 12) this.cache.delete(this.cache.keys().next().value);
        this.cache.set(key, canvas);
        return canvas;
      }

      async draw(num, canvas) {
        const ctx = canvas.getContext('2d');
        if (!num || num < 1 || num > this.pages) {
          canvas.width = 1;
          canvas.height = 1;
          ctx.clearRect(0, 0, 1, 1);
          canvas.parentElement.style.visibility = 'hidden';
          return;
        }
        canvas.parentElement.style.visibility = 'visible';
        const src = await this.getPageCanvas(num);
        canvas.width = src.width;
        canvas.height = src.height;
        ctx.drawImage(src, 0, 0);
      }

      async flip(direction) {
        if (!this.doc || this.busy) return;
        const next = this.view + direction;
        if (next < 0 || next > this.maxView()) return;

        this.busy = true;
        const current = this.pageNumbers(this.view);
        const target = this.pageNumbers(next);

        const frontNum = direction > 0 ? current.right : current.left;
        const backNum = direction > 0 ? target.left || target.right : target.right || target.left;

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!frontNum || reduced) {
          this.view = next;
          await this.update();
          this.busy = false;
          return;
        }

        this.leaf.classList.remove('fbs-leaf--forward', 'fbs-leaf--back');
        this.leaf.classList.add(direction > 0 ? 'fbs-leaf--forward' : 'fbs-leaf--back');

        await Promise.all([this.draw(frontNum, this.leafFront), this.draw(backNum, this.leafBack)]);

        this.leaf.style.transition = 'none';
        this.leaf.style.transform = 'rotateY(0deg)';
        this.leaf.classList.add('is-flipping');
        void this.leaf.offsetWidth;
        this.leaf.style.transition = '';
        this.leaf.style.transform = direction > 0 ? 'rotateY(-180deg)' : 'rotateY(180deg)';

        // Zielzustand schon während der Animation vorbereiten
        this.view = next;
        await this.update();

        setTimeout(() => {
          this.leaf.classList.remove('is-flipping');
          this.leaf.style.transition = 'none';
          this.leaf.style.transform = 'rotateY(0deg)';
          this.busy = false;
        }, this.flipMs);
      }
    }

    customElements.define('flip-shelf', FlipShelf);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-collection-list')) {
    customElements.define(
      'custom-collection-list',
      class CustomCollectionList extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          if (!this.track || !this.prev || !this.next) return;

          this.onPrev = () => this.scrollByPage(-1);
          this.onNext = () => this.scrollByPage(1);
          this.onScroll = () => this.sync();

          this.prev.addEventListener('click', this.onPrev);
          this.next.addEventListener('click', this.onNext);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          this.ro = new ResizeObserver(() => this.sync());
          this.ro.observe(this.track);

          this.sync();
        }

        disconnectedCallback() {
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.track) this.track.removeEventListener('scroll', this.onScroll);
          if (this.ro) this.ro.disconnect();
        }

        scrollByPage(direction) {
          this.track.scrollBy({ left: direction * this.track.clientWidth * 0.9, behavior: 'smooth' });
        }

        // Pfeile nur zeigen, wenn es wirklich etwas zu scrollen gibt
        sync() {
          var scrollable = this.track.scrollWidth - this.track.clientWidth > 4;
          this.classList.toggle('ccl--has-arrows', scrollable);
          if (!scrollable) return;

          var left = this.track.scrollLeft;
          var max = this.track.scrollWidth - this.track.clientWidth;
          this.prev.disabled = left <= 2;
          this.next.disabled = left >= max - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lamp-drop-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lamp-drop')) {
    const clamp = (v, min = 0, max = 1) => Math.min(max, Math.max(min, v));
    const range = (v, a, b) => (b <= a ? (v >= b ? 1 : 0) : clamp((v - a) / (b - a)));
    const lerp = (a, b, t) => a + (b - a) * t;
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

    // Zeitplan über den Scrollfortschritt der Bühne (0–1)
    const TIMELINE_FEATURED = {
      before: [0.04, 0.24],
      featIn: [0.24, 0.36],
      featHold: [0.36, 0.54],
      featOut: [0.54, 0.66],
      after: [0.64, 0.82],
      info: [0.8, 0.88],
      loop: [0.84, 0.92]
    };

    const TIMELINE_SIMPLE = {
      before: [0.04, 0.55],
      info: [0.55, 0.65],
      loop: [0.6, 0.7]
    };

    class LampDrop extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.classList.add('lds--static');
        }
        if (this.classList.contains('lds--static')) return;

        this.stage = this.querySelector('[data-stage]');
        this.logo = this.querySelector('[data-logo]');
        this.grid = this.querySelector('[data-grid]');
        this.feature = this.querySelector('[data-feature]');
        this.video = this.querySelector('[data-video]');
        this.bg = this.querySelector('.lds__bg');
        this.featureLamp = this.feature ? this.feature.querySelector('.lds-lamp') : null;
        this.slots = Array.from(this.querySelectorAll('.lds-slot'));
        this.lamps = this.slots.map((slot) => slot.querySelector('.lds-lamp'));
        this.n = this.lamps.length;

        const featured = parseInt(this.dataset.featured, 10) || 0;
        this.F = this.featureLamp && featured > 0 && featured <= this.n ? featured - 1 : -1;
        this.T = this.F >= 0 ? TIMELINE_FEATURED : TIMELINE_SIMPLE;

        this.maxScale = Math.max(1, parseFloat(this.dataset.scale) || 1.8);
        this.move = Math.max(0.2, parseFloat(this.dataset.move) || 3);
        this.hold = Math.max(0, parseFloat(this.dataset.hold) || 0);
        this.offset = Math.max(0, parseFloat(this.dataset.offset) || 0);

        this.k = 1;
        this.target = 0;
        this.current = 0;
        this.ready = false;
        this.visible = false;
        this.loopTime = 0;
        this.last = 0;
        this.raf = null;
        this.layoutRaf = null;
        this.flowDist = 600;
        this.slotRects = [];
        this.featTarget = null;
        this.lastFeatW = -1;

        this.frame = this.frame.bind(this);
        this.onScroll = () => this.tick();
        this.requestLayout = () => {
          if (this.layoutRaf) return;
          this.layoutRaf = requestAnimationFrame(() => {
            this.layoutRaf = null;
            this.layout();
          });
        };

        this.classList.add('is-js');

        // Hintergrund aus dem Theme-Container lösen
        if (this.bg) {
          const cs = getComputedStyle(this);
          [
            '--lds-bg',
            '--lds-overlay',
            '--lds-op-start',
            '--lds-op-end',
            '--lds-blur-start',
            '--lds-blur-d',
            '--lds-blur-m',
            '--lds-video-zoom',
            '--lds-video-pos'
          ].forEach((name) => {
            const value = cs.getPropertyValue(name);
            if (value) this.bg.style.setProperty(name, value.trim());
          });
          this.bg.style.backgroundColor = cs.getPropertyValue('--lds-bg').trim();
          this.bg.classList.add('lds-bg--portal');
          document.body.appendChild(this.bg);
        }

        this.ro = new ResizeObserver(this.requestLayout);
        this.ro.observe(this.stage);
        if (this.grid) this.ro.observe(this.grid);
        if (this.logo) this.ro.observe(this.logo);

        this.io = new IntersectionObserver(
          ([entry]) => {
            this.visible = entry.isIntersecting;
            this.classList.toggle('is-onscreen', this.visible);
            if (this.bg) this.bg.classList.toggle('is-onscreen', this.visible);
            this.toggleVideo(this.visible);
            if (this.visible) {
              this.classList.add('is-logo');
              window.addEventListener('scroll', this.onScroll, { passive: true });
              window.addEventListener('resize', this.requestLayout);
              this.tick();
            } else {
              window.removeEventListener('scroll', this.onScroll);
              window.removeEventListener('resize', this.requestLayout);
            }
          },
          { rootMargin: '0px 0px -10% 0px' }
        );
        this.io.observe(this);

        this.layout();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.requestLayout);
        if (this.bg && this.bg.parentNode === document.body) this.bg.remove();
        if (this.raf) cancelAnimationFrame(this.raf);
        if (this.layoutRaf) cancelAnimationFrame(this.layoutRaf);
        this.raf = null;
        this.layoutRaf = null;
      }

      // Raster in die verfügbare Höhe einpassen (echte Breite, kein Zoom) + Positionen messen
      layout() {
        if (!this.grid) return;

        // Volle Fensterbreite: Versatz zum linken Fensterrand wirklich messen,
        // statt ihn aus der Containerbreite zu berechnen (Theme-Container sind
        // nicht immer mittig).
        if (this.classList.contains('lds--full')) {
          this.style.setProperty('--lds-vw', 'auto');
          this.style.setProperty('--lds-shift', '0px');
          const natural = this.getBoundingClientRect();
          const vw = document.documentElement.clientWidth || window.innerWidth;
          this.style.setProperty('--lds-vw', vw + 'px');
          this.style.setProperty('--lds-shift', (-natural.left).toFixed(2) + 'px');
        }

        const stageH = this.stage.clientHeight;
        const stageW = this.stage.clientWidth;
        const cs = getComputedStyle(this.stage);
        const padBottom = parseFloat(cs.paddingBottom) || 0;

        for (let pass = 0; pass < 4; pass++) {
          const gridTop = this.grid.getBoundingClientRect().top - this.stage.getBoundingClientRect().top;
          const avail = stageH - padBottom - gridTop;
          const gridH = this.grid.offsetHeight;
          if (gridH <= 0 || avail <= 0) break;
          const next = clamp((this.k * avail) / gridH, 0.3, 1);
          if (Math.abs(next - this.k) < 0.004) break;
          this.k = next;
          this.style.setProperty('--lds-k', this.k.toFixed(4));
        }

        const sr = this.stage.getBoundingClientRect();
        this.flowDist = stageW * 0.65;

        this.slotRects = this.slots.map((slot) => {
          const r = slot.getBoundingClientRect();
          return { x: r.left - sr.left, y: r.top - sr.top, w: r.width, h: r.height };
        });

        if (this.F >= 0) {
          const slot = this.slotRects[this.F];
          const logoBottom = this.logo ? this.logo.getBoundingClientRect().bottom - sr.top : 0;
          const regionTop = logoBottom + 16;
          const regionH = Math.max(1, stageH - padBottom - regionTop);
          const w = Math.max(1, slot.w);
          const h = Math.max(1, slot.h);
          const scale = clamp(
            Math.min(this.maxScale, (regionH * 0.94) / h, (stageW * 0.8) / w),
            0.5,
            this.maxScale
          );
          const tw = w * scale;
          const th = h * scale;
          this.featTarget = {
            x: (stageW - tw) / 2,
            y: regionTop + (regionH - th) / 2,
            w: tw
          };
        }

        this.lastFeatW = -1;
        this.tick();
      }

      // Video nur abspielen, solange die Section sichtbar ist
      toggleVideo(play) {
        if (!this.video) return;
        if (play) {
          const attempt = this.video.play();
          if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
        } else {
          this.video.pause();
        }
      }

      tick() {
        if (this.raf) return;
        this.last = performance.now();
        this.raf = requestAnimationFrame(this.frame);
      }

      // Endlos-Zyklus: runter → Pause → hoch → Pause
      wave(t) {
        if (t <= 0) return 0;
        const m = this.move;
        const h = this.hold;
        const c = t % (2 * (m + h));
        if (c < m) return easeInOut(c / m);
        if (c < m + h) return 1;
        if (c < 2 * m + h) return 1 - easeInOut((c - m - h) / m);
        return 0;
      }

      flow(p, span, j, k) {
        const [a, b] = span;
        const len = Math.min(0.12, b - a);
        const step = k > 1 ? (b - a - len) / (k - 1) : 0;
        const start = a + j * step;
        return easeOut(range(p, start, start + len));
      }

      frame(now) {
        this.raf = null;
        const dt = Math.min(0.05, Math.max(0, (now - this.last) / 1000));
        this.last = now;

        const rect = this.getBoundingClientRect();
        const vh = window.innerHeight;
        this.target = clamp(-rect.top / Math.max(1, this.offsetHeight - vh));

        // Hintergrund exakt auf den sichtbaren Teil der Section begrenzen
        let edge = false;
        if (this.bg) {
          const top = Math.max(0, rect.top);
          const bottom = Math.max(0, vh - rect.bottom);
          this.bg.style.clipPath = 'inset(' + top.toFixed(1) + 'px 0px ' + bottom.toFixed(1) + 'px 0px)';
          edge = top > 0 || bottom > 0;
        }

        if (!this.ready) {
          this.current = this.target;
          this.ready = true;
        }

        let moving = false;
        const diff = this.target - this.current;
        if (Math.abs(diff) > 0.0003) {
          this.current += diff * 0.12;
          moving = true;
        } else {
          this.current = this.target;
        }

        const p = this.current;
        const T = this.T;
        const F = this.F;
        const n = this.n;

        const infoAll = easeOut(range(p, T.info[0], T.info[1]));
        const mix = easeInOut(range(p, T.loop[0], T.loop[1]));

        if (mix > 0) this.loopTime += dt;
        else this.loopTime = 0;

        let dim = 0;
        let inF = 0;
        let out = 0;
        if (F >= 0) {
          inF = easeInOut(range(p, T.featIn[0], T.featIn[1]));
          out = easeInOut(range(p, T.featOut[0], T.featOut[1]));
          dim = easeOut(range(p, T.featIn[0], T.featIn[1])) * (1 - easeOut(range(p, T.featOut[0], T.featOut[1])));
        }

        this.classList.toggle('is-info', infoAll > 0.6);

        // Weichzeichner + Farbschleier wachsen mit dem Scrollen
        const blurp = easeOut(range(p, 0, 0.85)).toFixed(4);
        this.style.setProperty('--lds-blurp', blurp);
        if (this.bg) this.bg.style.setProperty('--lds-blurp', blurp);

        const beforeCount = F >= 0 ? F : n;
        const afterCount = F >= 0 ? n - F - 1 : 0;

        for (let i = 0; i < n; i++) {
          const lamp = this.lamps[i];
          let tx = 0;
          let op = 1;

          if (F < 0 || i < F) {
            const show = this.flow(p, T.before, i, beforeCount);
            tx = (1 - show) * -this.flowDist;
            op = show;
          } else if (i === F) {
            op = out >= 0.999 ? 1 : 0;
          } else {
            const show = this.flow(p, T.after, i - F - 1, afterCount);
            tx = (1 - show) * -this.flowDist;
            op = show;
          }

          if (i !== F) op *= 1 - 0.7 * dim;

          const d = mix * this.wave(this.loopTime - i * this.offset);

          lamp.style.transform = tx === 0 ? '' : 'translate3d(' + tx.toFixed(1) + 'px,0,0)';
          lamp.style.opacity = op.toFixed(4);
          lamp.style.setProperty('--lds-d', d.toFixed(4));
          lamp.style.setProperty('--lds-info', infoAll.toFixed(4));
        }

        // Fokus-Produkt: Position + echte Breite animieren
        if (F >= 0 && this.featTarget && this.slotRects[F]) {
          const active = inF > 0.0005 && out < 0.999;
          this.feature.classList.toggle('is-active', active);

          if (active) {
            const slot = this.slotRects[F];
            const t = this.featTarget;
            const x = lerp(t.x, slot.x, out) - (1 - inF) * this.flowDist;
            const y = lerp(t.y, slot.y, out);
            const w = lerp(t.w, slot.w, out);

            if (Math.abs(w - this.lastFeatW) > 0.05) {
              this.feature.style.width = w.toFixed(2) + 'px';
              this.lastFeatW = w;
            }
            this.feature.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
            this.feature.style.opacity = easeOut(range(p, T.featIn[0], T.featIn[0] + (T.featIn[1] - T.featIn[0]) * 0.6)).toFixed(4);

            const h = range(p, T.featHold[0], T.featHold[1]);
            const d = h < 0.5 ? easeInOut(h * 2) : 1 - easeInOut((h - 0.5) * 2);
            const info =
              easeOut(range(p, T.featHold[0], T.featHold[0] + 0.04)) *
              (1 - easeOut(range(p, T.featHold[1] - 0.04, T.featHold[1])));

            this.featureLamp.style.setProperty('--lds-d', d.toFixed(4));
            this.featureLamp.style.setProperty('--lds-info', info.toFixed(4));
          }
        }

        if (moving || (this.visible && (mix > 0 || edge))) {
          this.raf = requestAnimationFrame(this.frame);
        }
      }
    }

    customElements.define('lamp-drop', LampDrop);
  }

  } catch(e) { console.error(e); }
})();
})();
